import { render, staticRenderFns } from "./internacao.vue?vue&type=template&id=c6ff76f4"
import script from "./internacao.vue?vue&type=script&lang=js"
export * from "./internacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports